<template>
    <div class="MyChat">
      <div class="my_user">
        <div class="name">{{ name }}</div>
        <div class="other_main">
          <div style="display:flex;flex-direction: column;align-items: end;">
            <div class="time">{{ time }}</div>
            <div class="geo"  v-if="message.msg_type === 'location'">
              <!-- 地图信息 -->
              <geo-element :message="message"></geo-element>
            </div>
            <div class="other_message">
              <div v-if="msg_type === 'text'">
                  <div v-if="con.indexOf('/emoji')===-1">{{ con }}</div>
                  <div v-else v-html="con" class="emoji"></div>
              </div>
              <div v-else-if="msg_type === 'image'">
                  <img :src="con" alt="" style="width: 100px; height: auto;">
              </div>
            </div>
          </div>
          <div class="avatar_warp">
            <avatar :src="avatar" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import GeoElement from '@/components/pc/message/message-elements/geo-element.vue'

  export default {
    name: "MyChat",
    components: {
        GeoElement
    },
    props: {
      time: {
        type: String,
        default: "",
      },
      avatar: {
        type: String,
        default: "",
      },
      con: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      msg_type: {
        type: String,
        default: "text",
      },
      message: {
      type: Object,
      required: true
    },
    },
  };
  </script>
  
  <style scoped>
  .time {
    text-align: right;
    color: #9a9a9a;
    padding-bottom: 10px;
    margin-right: 10px;
  }
  /* 我的信息 */
  .my_user {
    padding-bottom: 30px;
  }
  .other_main {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .other_message {
    display: inline-block;
    padding: 5px 16px;
    border-radius: 20px;
    color: #000;
    line-height: 25px;
    background-color: rgb(228, 243, 255);
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    margin-right: 12px;
  }
  .name {
    text-align: right;
    margin-right: 2px;
    margin-bottom: 5px;
    font-weight: bold;
  }
  </style>
  